import React, { useState, useEffect } from "react";
import Notification from "./Notification";
import { useTranslation } from "react-i18next";
import { GET } from "../../utils/fetchUtil";

function NotificationPanel() {
  const [notifications, setNotifications] = useState([]);
  const [stats, setStats] = useState({
    read: 0,
    unread: 0,
  });
  const { t } = useTranslation();

  const countByStatus = (notifications, status) =>
    notifications.filter((notification) => notification.status === status).length;

  useEffect(() => {
    GET("/notifications", (notifications) => {
      setNotifications(notifications);
      setStats({
        read: countByStatus(notifications, 1),
        unread: countByStatus(notifications, 0),
      });
    });
  }, []);

  return (
    <>
      <div className="content">
        <div className="subtitle">{`${t("notifications.unread")} (${stats.unread})`}</div>
        {notifications
          .filter((notification) => notification.status === 0)
          .map((notification) => (
            <Notification
              key={`notification${notification.id}`}
              title={notification.title}
              subject={notification.subject}
              status={notification.status}
              date={notification.date}
              linkLabel={notification.linkLabel}
            />
          ))}
      </div>
      <div className="content">
        <div className="subtitle">{`${t("notifications.read")} (${stats.read})`}</div>
        {notifications
          .filter((notification) => notification.status === 1)
          .map((notification) => (
            <Notification
              key={`notification${notification.id}`}
              title={notification.title}
              subject={notification.subject}
              status={notification.status}
              date={notification.date}
              linkLabel={notification.linkLabel}
            />
          ))}
      </div>
    </>
  );
}

export default NotificationPanel;
